module.exports = __webpack_public_path__ + "img/Static.834a9aa3.svg";